import _ from 'lodash'
import { AnyConceptStatus, ConceptStatus, ConceptStatusValue, ConceptStatusValueType } from '@fusion-advantage/backcompat'
import { timestamp } from '../util'

export const getConceptStatusValue = (conceptStatus: AnyConceptStatus|null): ConceptStatusValue => {
	// avoid untyped javascript blowing this up
	return _.get(conceptStatus, 'value', null)
}
export const statusValue = getConceptStatusValue

export const getSubconceptStatusValue = (conceptStatus: AnyConceptStatus|null, subconceptCid: string): ConceptStatusValue => {
	// avoid untyped javascript blowing this up
	return _.get(conceptStatus, `subconcepts['${subconceptCid}'].value`, null)
}
export const substatusValue = getSubconceptStatusValue

// for old times' sake
export const FPO_RESULT_USERID = 'cummerata.jacques@fusion-advantage.com'
export const FPO_RESULT_LOCATION = '32.7896316,-97.3482998'

export const newFpoConceptStatus = (cid: string, value: ConceptStatusValue, valueType: ConceptStatusValueType = ConceptStatusValueType.Chosen): ConceptStatus => {
	return {
		cid,
		value,
		valueType,
		updatedAt: timestamp(),
		userId: FPO_RESULT_USERID,
		location: FPO_RESULT_LOCATION,
	}
}
